module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.content), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.id))]), _vm._v(" "), _c('td', [_vm._v("/r/" + _vm._s(row.sub))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.score))]), _vm._v(" "), _c('td', [(row.media_type === 'link') ? _c('span', [_vm._v("URL")]) : (row.media_type === 'image') ? _c('span', [_vm._v("IMAGE")]) : (row.media_type === 'rich:video') ? _c('span', [_vm._v("VIDEO")]) : (row.media_type === 'self' || row.media_type == null) ? _c('span', [_vm._v("THREAD")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("UNIXcalendarDate")(row.created_utc)))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": row.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.type('view ' + row.id)
        }
      }
    }, [_vm._v(_vm._s(row.title))])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('td', [_vm._v("ID")]), _vm._v(" "), _c('td', [_vm._v("SUB")]), _vm._v(" "), _c('td', [_vm._v("SCORE")]), _vm._v(" "), _c('td', [_vm._v("TYPE")]), _vm._v(" "), _c('td', [_vm._v("DATE")]), _vm._v(" "), _c('td', [_vm._v("TITLE")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a1435aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/responses/table.vue
// module id = 291
// module chunks = 2